import { CPAttachment } from "../../api/models/unified";
import { MAIN_IMAGE_ROOT } from "../../app_config";
import Icon from "../icon/Icon";

interface AttachmentThumbnailProps {
  attachment: CPAttachment;
  isImage?: boolean;
  size?: "small" | "medium" | "large";
  fileMode?: "link" | "thumbnail";
}

const sizeConfig = {
  small: {
    width: "40px",
    height: "40px",
    className: "h-10 w-10 rounded-md object-cover",
  },
  medium: {
    width: "80px",
    height: "80px",
    className: "h-20 w-20 rounded-md object-cover",
  },
  large: {
    width: "120px",
    height: "120px",
    className: "h-30 w-30 rounded-md object-cover",
  },
};

const AttachmentThumbnail = ({
  attachment,
  isImage,
  size = "medium",
  fileMode = "link",
}: AttachmentThumbnailProps) => {
  if (isImage) {
    return (
      <img
        src={`${MAIN_IMAGE_ROOT}${attachment.publicUrl}`}
        width={sizeConfig[size].width}
        height={sizeConfig[size].height}
        alt={attachment.name}
        className={sizeConfig[size].className}
      />
    );
  }

  if (fileMode === "thumbnail") {
    return (
      <div
        title={attachment.name}
        style={{
          width: sizeConfig[size].width,
          height: sizeConfig[size].height,
        }}
        className="bg-gray50 flex items-center justify-center rounded-md"
      >
        <Icon size="extra" name="paperclip" />
      </div>
    );
  }

  return (
    <div className="flex flex-row items-center gap-2">
      <Icon size="small" name="paperclip" />
      <span className="text-primary hover:text-primary-accent text-[14px]/[20px] not-italic underline">
        {attachment.name}
      </span>
    </div>
  );
};

export default AttachmentThumbnail;
